<template>
  <div class="bg-image">
    <div class="row g-0 justify-content-center bg-xwork-dark">
      <div
        class="hero-static col-sm-8 col-md-6 col-xl-4 d-flex align-items-center p-2 px-sm-0"
      >
        <!-- Sign In Block -->
        <div
          class="block block-transparent block-rounded w-100 mb-0 overflow-hidden"
        >
          <div
            class="block-content block-content-full px-lg-5 px-xl-6 py-4 py-md-5 py-lg-6 bg-body-extra-light"
          >
            <!-- Header -->
            <div class="text-center">
              <router-link class="" :to="{ name: 'login' }">
                <Logo :width="150" :height="150" currentColor="#00031c"></Logo>
              </router-link>
              <p class="text-uppercase fw-bold fs-sm text-muted">
                Inciar Sesion
              </p>
            </div>
            <div class="js-validation-signin">
              <div class="mb-4">
                <div class="input-group input-group-lg">
                  <input
                    type="email"
                    class="form-control"
                    id="login-username"
                    name="login-username"
                    placeholder="Email"
                    v-model="data.user.email"
                  />
                  <span class="input-group-text">
                    <i class="fa fa-user-circle"></i>
                  </span>
                </div>
              </div>
              <div class="mb-4">
                <div class="input-group input-group-lg">
                  <input
                    type="password"
                    class="form-control"
                    id="login-password"
                    name="login-password"
                    placeholder="Password"
                    v-model="data.user.password"
                  />

                  <a
                    class="btn btn-outline-secondary"
                    id="togglePassword"
                    @click="showPassword('login-password', 'toggleIconLogin')"
                  >
                    <i class="fa fa-eye" id="toggleIconLogin"></i>
                  </a>
                </div>
              </div>
              <div
                class="d-sm-flex justify-content-sm-between align-items-sm-center text-center text-sm-start mb-4"
              >
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="login-remember-me"
                    name="login-remember-me"
                    checked
                  />
                  <label class="form-check-label" for="login-remember-me"
                    >Remember Me</label
                  >
                </div>
                <div class="fw-semibold fs-sm py-1">
                  <router-link :to="{ name: 'password-reset' }">
                    Perdiste la Contraseña?</router-link
                  >
                </div>
              </div>
              <div class="text-center mb-4">
                <button
                  @click="check_form()"
                  type="submit"
                  class="btn btn-hero btn-primary"
                >
                  <i class="fa fa-fw fa-sign-in-alt opacity-50 me-1"></i> Entrar
                </button>
              </div>
            </div>
            <!-- END Sign In Form -->
          </div>
        </div>
        <!-- END Sign In Block -->
      </div>
    </div>
  </div>
</template>

<script setup>
import Logo from "@/components/Logo.vue";
import useLogin from "@/composables/useLogin";
const { data, check_form, showPassword } = useLogin();
</script>
